import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface SuggestedViewState {
  value: boolean;
}

const initialState: SuggestedViewState = { value: false };

export const suggestedViewSlice = createSlice({
  name: 'suggestedView',
  initialState,
  reducers: {
    setSuggestedView: (state: SuggestedViewState, action: PayloadAction<boolean>) => {
      state.value = action.payload;
    },
  },
});

export const selectedSuggestedView = (state: RootState) => state.suggestedView.value;

export const { setSuggestedView } = suggestedViewSlice.actions;

export default suggestedViewSlice.reducer;
